/**
 * @file automatically generated from MApp.Data.LoadingType
 */

export enum LoadingType {
    LiveVector = 1,
    CachedVector = 2,
    Wms = 3,
    Wmts = 4,
    Ecwp = 5,
    Wfs = 6,
    Osm = 7,
    Here = 8
}
